export default __webpack_public_path__ + "static/media/capitallux.72f22f10.jpg";